import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	emptyStarredSectionMessage: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.empty-starred-section-message',
		defaultMessage: 'Select the star icon next to your queues to add them here.',
		description: 'Text displayed to user when there are no queues to display in starred section.',
	},
	starredHeader: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.starred-section.starred-header',
		defaultMessage: 'Starred',
		description: 'Header for starred section',
	},
});
